<template>
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        class="shape"
        transform="translate(-170.000000, -625.000000)"
        fill-rule="nonzero"
      >
        <g
          id="Group-6"
          transform="translate(123.000000, 625.000000)"
        >
          <g id="Group-7">
            <g
              id="Group-3"
              transform="translate(5.000000, 0.000000)"
            >
              <g
                id="iconmonstr-instagram-13"
                transform="translate(42.000000, 0.000000)"
              >
                <path
                  id="Shape"
                  d="M20.3106667,7.31733333 C19.1866667,7.26666667 18.848,7.256 16,7.256 C13.152,7.256 12.8146667,7.26666667 11.6906667,7.31733333 C8.79733333,7.44933333 7.44933333,8.82 7.31866667,11.6893333 C7.26666667,12.8146667 7.25466667,13.152 7.25466667,16 C7.25466667,18.848 7.26666667,19.1853333 7.31733333,20.3106667 C7.44933333,23.1746667 8.792,24.5506667 11.6893333,24.6826667 C12.8133333,24.7333333 13.152,24.7453333 16,24.7453333 C18.8493333,24.7453333 19.1866667,24.7346667 20.3106667,24.684 C23.204,24.552 24.5506667,23.1786667 24.6826667,20.312 C24.7333333,19.1866667 24.744,18.8493333 24.744,16.0013333 C24.744,13.1533333 24.7333333,12.816 24.6826667,11.692 C24.5506667,8.82133333 23.2013333,7.44933333 20.3106667,7.31733333 Z M16,21.4773333 C12.9746667,21.4773333 10.5226667,19.0253333 10.5226667,16 C10.5226667,12.9746667 12.976,10.5226667 16,10.5226667 C19.024,10.5226667 21.4773333,12.9746667 21.4773333,16 C21.4773333,19.0253333 19.0253333,21.4773333 16,21.4773333 Z M21.6946667,11.5866667 C20.988,11.5866667 20.4146667,11.0133333 20.4146667,10.3066667 C20.4146667,9.6 20.988,9.02666667 21.6946667,9.02666667 C22.4013333,9.02666667 22.9746667,9.6 22.9746667,10.3066667 C22.9746667,11.0133333 22.4013333,11.5866667 21.6946667,11.5866667 Z M19.556,16 C19.556,17.964 17.964,19.556 16,19.556 C14.036,19.556 12.444,17.964 12.444,16 C12.444,14.036 14.036,12.444 16,12.444 C17.964,12.444 19.556,14.036 19.556,16 Z M25.3333333,0 L6.66666667,0 C2.98533333,0 0,2.98533333 0,6.66666667 L0,25.3333333 C0,29.0146667 2.98533333,32 6.66666667,32 L25.3333333,32 C29.016,32 32,29.0146667 32,25.3333333 L32,6.66666667 C32,2.98533333 29.016,0 25.3333333,0 Z M26.6026667,20.3973333 C26.4266667,24.276 24.268,26.4253333 20.3986667,26.6026667 C19.26,26.6546667 18.8973333,26.6666667 16,26.6666667 C13.1026667,26.6666667 12.7413333,26.6546667 11.6026667,26.6026667 C7.72533333,26.4253333 5.576,24.272 5.39733333,20.3973333 C5.34533333,19.26 5.33333333,18.8973333 5.33333333,16 C5.33333333,13.104 5.34533333,12.74 5.39733333,11.6026667 C5.576,7.72533333 7.728,5.57466667 11.6026667,5.39866667 C12.7413333,5.34533333 13.1026667,5.33333333 16,5.33333333 C18.8973333,5.33333333 19.26,5.34533333 20.3986667,5.39733333 C24.276,5.57466667 26.4293333,7.732 26.6026667,11.6013333 C26.6546667,12.74 26.6666667,13.104 26.6666667,16 C26.6666667,18.8973333 26.6546667,19.26 26.6026667,20.3973333 Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
    export default {
        name:'Instagram'
    }
</script>

<style lang="scss" scoped>

</style>